import { Link, useHistory } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import PhoneIcon from "@mui/icons-material/Phone";

export default function NavBar() {
  const history = useHistory();

  const handleLogout = () => {
    localStorage.removeItem("liyu_login_token");
    localStorage.removeItem("liyu_phone");
    localStorage.removeItem("selected_seats_/portal/view-buses");
    localStorage.removeItem("selected_seats_11160");

    history.push("/login");
  };
  return (
    <AppBar component="nav">
      <Toolbar>
        <Typography
          variant="h6"
          component="div"
          sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}
        >
          <Link
            to="/"
            style={{
              color: "inherit",
              textDecoration: "none",
              fontFamily: "inherit",
            }}
          >
            LIYU BUS TICKET
          </Link>
        </Typography>
        <Box sx={{ display: { xs: "none", sm: "block" } }}>
          <Link to="/" style={{ color: "inherit", textDecoration: "none" }}>
            <Button sx={{ color: "#fff" }}>Home</Button>
          </Link>
          <Link
            to="/pending-ticket"
            style={{ color: "inherit", textDecoration: "none" }}
          >
            <Button sx={{ color: "#fff" }}>Pending Ticket</Button>
          </Link>
          {/* <Link
            to="/search-ticket"
            style={{ color: "inherit", textDecoration: "none" }}
          >
            <Button sx={{ color: "#fff" }}>Search Ticket</Button>
          </Link> */}
          {/* <Link
            to="/view-buses"
            style={{ color: "inherit", textDecoration: "none" }}
          >
            <Button sx={{ color: "#fff" }}>View Buses</Button>
          </Link>           */}
          {/* <Link
            to="/payment"
            style={{ color: "inherit", textDecoration: "none" }}
          >
            <Button sx={{ color: "#fff" }}>Payment</Button>
          </Link> */}
          {/*<Link
            to="/download-ticket"
            style={{ color: "inherit", textDecoration: "none" }}
          >
            <Button sx={{ color: "#fff" }}>Download Ticket</Button>
          </Link>*/}
          <Button startIcon={<PhoneIcon />} sx={{ color: "#fff" }}>
            <a
              href="tel:9439"
              style={{ color: "inherit", textDecoration: "none" }}
            >
              9439
            </a>
            &nbsp;/&nbsp;
            <a
              href="tel:+251982117777"
              style={{ color: "inherit", textDecoration: "none" }}
            >
              0982117777
            </a>
          </Button>

          <Button variant="contained" sx={{ background: "#111" }}>
            <a
              href="https://www.liyubus.com"
              style={{ color: "inherit", textDecoration: "none" }}
            >
              {" "}
              Liyu
            </a>
          </Button>

          <Button
            variant="outlined"
            color="inherit"
            onClick={handleLogout}
            sx={{ ml: 2 }}
          >
            Logout
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
